export const BaseDict = {
    ViewAllButton: "View All",
    LiveIndicator: "LIVE",
    FirstOvertime: "FirstOvertime",
    BreakAfterFirstOvertime: "BreakAfterFirstOvertime",
    SecondOvertime: "SecondOvertime",
    FirstSet: "FirstSet",
    SecondSet: "SecondSet",
    ThirdSet: "ThirdSet",
    FourthSet: "FourthSet",
    FifthSet: "FifthSet",
    FirstPeriod: "FirstPeriod",
    BreakAfterFirstPeriod: "BreakAfterFirstPeriod",
    SecondPeriod: "SecondPeriod",
    BreakAfterSecondPeriod: "BreakAfterSecondPeriod",
    ThirdPeriod: "ThirdPeriod",
    BreakAfterThirdPeriod: "BreakAfterThirdPeriod",
    FirstQuarter: "FirstQuarter",
    BreakAfterFirstQuarter: "BreakAfterFirstQuarter",
    SecondQuarter: "SecondQuarter",
    BreakAfterSecondQuarter: "BreakAfterSecondQuarter",
    ThirdQuarter: "ThirdQuarter",
    BreakAfterThirdQuarter: "BreakAfterThirdQuarter",
    FourthQuarter: "FourthQuarter",
    BreakAfterFourthQuarter: "BreakAfterFourthQuarter",
    Overtime: "Overtime",
    FirstHalf: "FirstHalf",
    SecondHalf: "SecondHalf",
    BreakAfterFirstHalf: "BreakAfterFirstHalf",
    StartsIn: "Starts in:",
    TooltipMessage: "Live streaming available",
    Finished: "Finished",
    BreakAfterSecondOvertime: "BreakAfterSecondOvertime",
    PenaltyShootout: "PenaltyShootout",
    FirstInning: "FirstInning",
    SecondInning: "SecondInning",
    ThirdInning: "ThirdInning",
    FourthInning: "FourthInning",
    FifthInning: "FifthInning",
    SixthInning: "SixthInning",
    SeventhInning: "SeventhInning",
    EighthInning: "EighthInning",
    NinthInning: "NinthInning",
    TenthInning: "TenthInning",
    EleventhInning: "EleventhInning",
    TwelfthInning: "TwelfthInning",
    ThirteenthInning: "ThirteenthInning",
    FourteenthInning: "FourteenthInning",
    FifteenthInning: "FifteenthInning",
    BreakAfterFirstInning: "BreakAfterFirstInning",
    BreakAfterSecondInning: "BreakAfterSecondInning",
    BreakAfterThirdInning: "BreakAfterThirdInning",
    BreakAfterFourthInning: "BreakAfterFourthInning",
    BreakAfterFifthInning: "BreakAfterFifthInning",
    BreakAfterSixthInning: "BreakAfterSixthInning",
    BreakAfterSeventhInning: "BreakAfterSeventhInning",
    BreakAfterEighthInning: "BreakAfterEighthInning",
    BreakAfterNinthInning: "BreakAfterNinthInning",
    BreakAfterTenthInning: "BreakAfterTenthInning",
    BreakAfterEleventhInning: "BreakAfterEleventhInning",
    BreakAfterTwelfthInning: "BreakAfterTwelfthInning",
    BreakAfterThirteenthInning: "BreakAfterThirteenthInning",
    BreakAfterFourteenthInning: "BreakAfterFourteenthInning",
    FirstGame: "FirstGame",
    SecondGame: "SecondGame",
    ThirdGame: "ThirdGame",
    FirstFrame: "FirstFrame",
    SecondFrame: "SecondFrame",
    ThirdFrame: "ThirdFrame",
    FourthFrame: "FourthFrame",
    FifthFrame: "FifthFrame",
    SixthFrame: "SixthFrame",
    SeventhFrame: "SeventhFrame",
    EighthFrame: "EighthFrame",
    NinthFrame: "NinthFrame",
    TenthFrame: "TenthFrame",
    EleventhFrame: "EleventhFrame",
    TwelfthFrame: "TwelfthFrame",
    ThirteenthFrame: "ThirteenthFrame",
    FourteenthFrame: "FourteenthFrame",
    FifteenthFrame: "FifteenthFrame"
};
//# sourceMappingURL=dict.js.map